import { createSlice } from "@reduxjs/toolkit";
import { ListViewOption } from "core/components/listToggle/listToggleControl";
import { WipFilterModel } from "core/models/WipFilterModel";
import { logger } from "utils/logger";
import * as styleService from "services/styleService";
import { MediaFilterModel } from "core/models";

const homeSlice = createSlice({
  name: "homeSlice",
  initialState: {
    wips: [],
    selectedWip: null,
    selectedStyles: [],
    displayPrefs: { mediaDisplayType: ListViewOption.GRID },
    wipFilter: { ...new WipFilterModel() },
    styleFilter: { ...new WipFilterModel() },
    styleMediaFilter: { ...new MediaFilterModel() },
    styles: [],
    selectedStyle: null,
    // standard props
    error: null,
    success: null,
    loading: false,
    action: null,
  },
  reducers: {
    setDisplayPrefs(state, action) {
      state.displayPrefs = { ...action.payload };
    },
    selectStyle(state, action) {
      logger.log("Setting Style: ", action.payload);
      state.selectedStyle = action.payload ? { ...action.payload } : null;
    },
    selectStyles(state, action) {
      logger.log("setting selected wips", action.payload);
      state.selectedStyles = action.payload ? [...action.payload] : [];
    },
    setWipFilter(state, action) {
      logger.log("Setting Wip: ", action.payload);
      state.wipFilter = action.payload ? { ...action.payload } : null;
    },
    setStyleFilter(state, action) {
      logger.log("Setting Style Filter: ", action.payload);
      state.styleFilter = action.payload ? { ...action.payload } : null;
    },
    setStyleMediaFilter(state, action) {
      logger.log("Setting Style Filter: ", action.payload);
      state.styleMediaFilter = action.payload ? { ...action.payload } : null;
    },

    //////////////////////
    //
    // GET STYLES
    //
    //////////////////////
    getStylesStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getStylesSuccess(state, action) {
      logger.log("getStyleSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Styles Success" };

      state.styles = [...action.payload];
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getStylesFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    //////////////////////
    //
    // SINGLE STYLE
    //
    //////////////////////
    getStyleStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getStyleSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Wip Success",
        data: action.payload,
      };
      // if(action.payload.urls){
      //   state.selectedProject = {...state.selectedProject, urls:action.payload.urls}
      // }
      state.selectedStyle = action.payload ? { ...action.payload } : null;
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getLatestStylesSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Wip Success",
        data: action.payload,
      };
      // if(action.payload.urls){
      //   state.selectedProject = {...state.selectedProject, urls:action.payload.urls}
      // }
      const updateMap = new Map(
        action.payload.map((item) => [item.styleNumber, item])
      );

      const styles = [...state.styles].map((item) => {
        const update = updateMap.get(item.styleNumber);
        return update ? { ...item, ...update } : item;
      });

      state.styles = styles;
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },


    getStyleFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    getWipTimelineSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Wip Timeline Success",
      };

      if (state.selectedWip) {
        state.selectedWip = {
          ...state.selectedWip,
          timeline: action.payload.Timeline,
        };
      }
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    clearNotifications(state, action) {
      state.error = null;
      state.success = null;
    },

    onServiceStart(state, action) {
      state.success = null;
      state.loading = true;
      state.error = null;
      // state.action = action.type;
    },
    onServiceFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
      state.loading = false;
    },
  },
});

// STYLES
export const fetchStylesByUnit = (criteria) => async (dispatch) => {
  try {
    dispatch(getStylesStart());
    const data = await styleService.getStylesByUnit(criteria);
    dispatch(getStylesSuccess(data));
  } catch (err) {
    logger.log("err", err);
    dispatch(getStylesFailure(err));
  }
};

export const fetchStyle = (id) => async (dispatch) => {
  try {
    dispatch(getStyleStart());
    // const data = await getStyleTimeline({ id: criteria.keyword });
    const data = await styleService.getStyle(id);
    dispatch(getStyleSuccess(data));
  } catch (err) {
    logger.log("err", err);
    dispatch(getStyleFailure(err));
  }
};

export const fetchLatestStyles = (items) => async (dispatch) => {
  try {
    dispatch(getStyleStart());
    // const data = await getStyleTimeline({ id: criteria.keyword });
    // const data = await styleService.getStyle(id);

    const results = await Promise.all(
      items.map((id) => styleService.getStyle(id))
    );

    dispatch(getLatestStylesSuccess(results));
  } catch (err) {
    logger.log("err", err);
    dispatch(getStylesFailure(err));
  }
};

export const {
  // selectWip,
  setWipFilter, 
  
  setDisplayPrefs,
  
  styleMediaFilter,
  setStyleMediaFilter,

  getWipTimelineSuccess,

  getStylesStart,
  getStylesSuccess,
  getStylesFailure,

  getStyleStart,
  getStyleSuccess,
  getStyleFailure,

  onServiceStart,
  onServiceFailure,

  getLatestStylesSuccess,

  clearNotifications,
} = homeSlice.actions;

export default homeSlice.reducer;
